import React, { useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import Photo from "./Photo";
import Modal1 from "../modals/Modal1";
import { isFolderAdmin } from "../pages/folder_pages/FolderHelpers";
// Styles for the modal
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  display: "flex",
  borderRadius: "10px", // Rounded corners
  overflow: "auto", // Hidden overflow for container
};

const PhotoModal = ({
  orgData,
  userData,
  document,
  folder,
  onFetch,
  validation,
}) => {
  const [open, setOpen] = useState(false);

  // Handlers to open and close the modal
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <div>
      {/* Button to open the modal */}

      <SecondaryButton onClick={handleOpen} disabled={false}>
        {isFolderAdmin(orgData, folder)
          ? "Gérer les photos"
          : orgData.id === folder.client_id
            ? "Déposer les photos"
            : "Voir les photos"}
      </SecondaryButton>

      {/* Modal that contains the PdfEditor */}
      <Modal1 isOpen={open} onClose={handleClose}>
        {/* This is where the PdfEditor will be rendered */}
        <div className="bg-neutral-200 flex flex-col  w-c1k rounded-3xl ">
          <Photo
            validation={validation}
            orgData={orgData}
            document={document}
            folder={folder}
            onClose={handleClose}
            onFetch={onFetch}
            userData={userData}
          />{" "}
        </div>
      </Modal1>
    </div>
  );
};

export default PhotoModal;
